export const ENVIRONMENTS = ['LOCAL', 'DEV', 'PROD', 'STAGING'] as const

export type Environment = (typeof ENVIRONMENTS)[number]

export const ENV = {
  LOCAL: 'LOCAL',
  DEV: 'DEV',
  PROD: 'PROD',
  STAGING: 'STAGING',
} as const satisfies Record<string, Environment>
